export default __webpack_public_path__ + "static/media/Animations_Bar0.38a7253f.svg";